import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../../common/services/api-status.enum";

const initialState = {
  deploymentDetails: {
    deploymentDetailsData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  addDeploymentSchedule: {
    addDeploymentScheduleData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  updateDeploymentSchedule: {
    updateDeploymentScheduleData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  deleteDeploymentSchedule: {
    deleteDeploymentScheduleData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
};

const deploymentSchedulerSlice = createSlice({
  name: "deploymentScheduler",
  initialState,
  reducers: {
    getDeploymentDetailsData: (state) => {
      state.deploymentDetails.deploymentDetailsData.status = ApiStatus.LOADING;
      state.deploymentDetails.deploymentDetailsData.error = null;
    },
    getDeploymentDetailsDataSuccess: (state, action) => {
      state.deploymentDetails.deploymentDetailsData.data = action.payload;
      state.deploymentDetails.deploymentDetailsData.status = ApiStatus.SUCCESS;
      state.deploymentDetails.deploymentDetailsData.error = null;
    },
    getDeploymentDetailsDataFailure: (state, action) => {
      state.deploymentDetails.deploymentDetailsData.status = ApiStatus.ERROR;
      state.deploymentDetails.deploymentDetailsData.error = action.payload;
    },
    addDeploymentScheduleData: (state) => {
      state.addDeploymentSchedule.addDeploymentScheduleData.status = ApiStatus.LOADING;
      state.addDeploymentSchedule.addDeploymentScheduleData.error = null;
    },
    addDeploymentScheduleDataSuccess: (state, action) => {
      state.addDeploymentSchedule.addDeploymentScheduleData.data = action.payload;
      state.addDeploymentSchedule.addDeploymentScheduleData.status = ApiStatus.SUCCESS;
      state.addDeploymentSchedule.addDeploymentScheduleData.error = null;
    },
    addDeploymentScheduleDataFailure: (state, action) => {
      state.addDeploymentSchedule.addDeploymentScheduleData.status = ApiStatus.ERROR;
      state.addDeploymentSchedule.addDeploymentScheduleData.error = action.payload;
    },
    resetAddDeploymentScheduleData: (state) => {
      state.addDeploymentSchedule.addDeploymentScheduleData.data = {};
      state.addDeploymentSchedule.addDeploymentScheduleData.status = ApiStatus.NONE;
      state.addDeploymentSchedule.addDeploymentScheduleData.error = null;
    },
    updateDeploymentScheduleData: (state) => {
      state.updateDeploymentSchedule.updateDeploymentScheduleData.status = ApiStatus.LOADING;
      state.updateDeploymentSchedule.updateDeploymentScheduleData.error = null;
    },
    updateDeploymentScheduleDataSuccess: (state, action) => {
      state.updateDeploymentSchedule.updateDeploymentScheduleData.data = action.payload;
      state.updateDeploymentSchedule.updateDeploymentScheduleData.status = ApiStatus.SUCCESS;
      state.updateDeploymentSchedule.updateDeploymentScheduleData.error = null;
    },
    updateDeploymentScheduleDataFailure: (state, action) => {
      state.updateDeploymentSchedule.updateDeploymentScheduleData.status = ApiStatus.ERROR;
      state.updateDeploymentSchedule.updateDeploymentScheduleData.error = action.payload;
    },
    resetUpdateDeploymentScheduleData: (state) => {
      state.updateDeploymentSchedule.updateDeploymentScheduleData.data = {};
      state.updateDeploymentSchedule.updateDeploymentScheduleData.status = ApiStatus.NONE;
      state.updateDeploymentSchedule.updateDeploymentScheduleData.error = null;
    },
    deleteDeploymentScheduleData: (state) => {
      state.deleteDeploymentSchedule.deleteDeploymentScheduleData.status = ApiStatus.LOADING;
      state.deleteDeploymentSchedule.deleteDeploymentScheduleData.error = null;
    },
    deleteDeploymentScheduleDataSuccess: (state, action) => {
      state.deleteDeploymentSchedule.deleteDeploymentScheduleData.data = action.payload;
      state.deleteDeploymentSchedule.deleteDeploymentScheduleData.status = ApiStatus.SUCCESS;
      state.deleteDeploymentSchedule.deleteDeploymentScheduleData.error = null;
    },
    deleteDeploymentScheduleDataFailure: (state, action) => {
      state.deleteDeploymentSchedule.deleteDeploymentScheduleData.status = ApiStatus.ERROR;
      state.deleteDeploymentSchedule.deleteDeploymentScheduleData.error = action.payload;
    },
    resetDeleteDeploymentScheduleData: (state) => {
      state.deleteDeploymentSchedule.deleteDeploymentScheduleData.data = {};
      state.deleteDeploymentSchedule.deleteDeploymentScheduleData.status = ApiStatus.NONE;
      state.deleteDeploymentSchedule.deleteDeploymentScheduleData.error = null;
    },
  },
});

export const {
  getDeploymentDetailsData,
  getDeploymentDetailsDataSuccess,
  getDeploymentDetailsDataFailure,
  addDeploymentScheduleData,
  addDeploymentScheduleDataSuccess,
  addDeploymentScheduleDataFailure,
  resetAddDeploymentScheduleData,
  updateDeploymentScheduleData,
  updateDeploymentScheduleDataSuccess,
  updateDeploymentScheduleDataFailure,
  resetUpdateDeploymentScheduleData,
  deleteDeploymentScheduleData,
  deleteDeploymentScheduleDataSuccess,
  deleteDeploymentScheduleDataFailure,
  resetDeleteDeploymentScheduleData,
} = deploymentSchedulerSlice.actions;

export default deploymentSchedulerSlice.reducer;
